import { isEmbed } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app/index.tsx';
import { getConfluenceMacroType } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/confluence-macro/index.tsx';
import { getIsProjectLimitExceeded } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/errors/index.tsx';
import { getIsIssuesLoading } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issues/index.tsx';
import { getPlan } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan/index.tsx';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types.tsx';
import { createStructuredSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect/index.tsx';
import type { StateProps } from './types.tsx';

export default createStructuredSelector<State, StateProps>({
	confluenceMacroType: getConfluenceMacroType,
	isLoading: getIsIssuesLoading,
	isProjectLimitExceeded: getIsProjectLimitExceeded,
	isEmbed,
	planInfo: getPlan,
});
